import dynamic from 'next/dynamic';
import { UserNameProps } from './UserName.types';

export const UserName = dynamic<UserNameProps>(() => import('./UserName').then(module => module.UserName));
